import { DeviceLimit, PaymentMethod, SUBSCRIPTION_TYPE } from "../context/types";
import { post, get } from "../utils/api";

export interface CreateOrder {
  paymentMethod: PaymentMethod,
  orderType: SUBSCRIPTION_TYPE,
  deviceLimit: DeviceLimit
}

export interface CreateAccessTrial {
  userId: number
}

export interface OrderApi {
  id: number;
  payId: string | null;
  userId: number;
  orderType: string;
  deviceLimit?: DeviceLimit | null;
  paymentMethod: string;
  createdAt: Date;
  amount: number;
  description: string;
  status: string;
  paymentUrl: string;
  orderPayId: string;
}

export const getOrderById = async (orderId: number): Promise<OrderApi | null> => {
  try {
    const order = await get<OrderApi | null>(`/orders/${orderId}`);
    return order;
  } catch(e) {
    window.location.href = '/subscription-fail';
    return new Promise((resolve) => resolve(null))
  }
};

export const getLastOrder = async (): Promise<string | null> => {
  try {
    const buyUrl = await get<string | null>(`/orders/actual`);
    return buyUrl;
  } catch(e) {
    window.location.href = '/subscription-fail';
    return new Promise((resolve) => resolve(null))
  }
};

export interface CreateOrderResponse {
  url: string;
  orderId: number;
}

export const createOrder = async (data: CreateOrder): Promise<CreateOrderResponse | null> => {
  try {
    const response = await post<CreateOrderResponse>(`/orders`, {}, data);
    return response;
  } catch(e) {
    window.location.href = '/subscription-fail';
    return new Promise((resolve) => resolve(null))
  }
};

export interface CreateDeviceUpgrade {
  paymentMethod: PaymentMethod;
  deviceLimit: DeviceLimit;
}

export interface CreateDeviceUpgradeResponse extends CreateOrderResponse {
  amount: number;
}

/**
 * Доплата за увеличение лимита устройств в рамках уже оплаченного периода подписки.
 * В отличие от createOrder не редиректит на /subscription-fail при ошибке — здесь
 * это чаще всего ожидаемая бизнес-валидация (мин. сумма, тариф не выше текущего
 * и т.п.), которую нужно показать прямо в модалке.
 */
export const createDeviceUpgradeOrder = async (
  data: CreateDeviceUpgrade
): Promise<CreateDeviceUpgradeResponse> => {
  return post<CreateDeviceUpgradeResponse>(`/orders/devices/upgrade`, {}, data);
};
